import { Button, Group, Stack } from '@mantine/core';
import { zodResolver } from '@mantine/form';
import { z } from 'zod';

import { useFormWithNameInputProp } from '@hooks/useFormWithNameInputProp';
import { IAdditionalFiscalReferenceItem } from '@interfaces';
import { getRoleTypes } from '@utils';
import { Select, TextInput } from './';

const roleTypes = getRoleTypes();

interface EditAdditionalFiscalReferenceProps {
  reference: IAdditionalFiscalReferenceItem | null;
  onHide(): void;
  onSave(updatedAdditionalFiscalReference: IAdditionalFiscalReferenceItem): void;
}

const additionalFiscalReferenceSchema = z.object({
  role: z.string().min(1, 'Role is required'),
  vatIdentificationNumber: z.string().min(1, 'VAT identification number is required'),
});

type EditAdditionalFiscalReferenceFormValues = z.infer<typeof additionalFiscalReferenceSchema>;

export const EditAdditionalFiscalReference = (props: EditAdditionalFiscalReferenceProps) => {
  const { reference, onHide, onSave } = props;

  const form = useFormWithNameInputProp({
    initialValues: {
      role: reference?.role || '',
      vatIdentificationNumber: reference?.vatIdentificationNumber || '',
    },
    validate: zodResolver(additionalFiscalReferenceSchema),
    validateInputOnBlur: true,
  });

  const handleSubmit = (values: EditAdditionalFiscalReferenceFormValues) => {
    const { role, vatIdentificationNumber } = values;

    const newAdditionalFiscalReference = {
      role,
      vatIdentificationNumber,
    };

    onSave(newAdditionalFiscalReference);
    onHide();
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack>
        <Select {...form.getInputProps('role')} label="Role type" data={roleTypes} searchable size="lg" data-pw="select-role-dropdown" />
        <TextInput {...form.getInputProps('vatIdentificationNumber')} label="Vat identification number" />
      </Stack>
      <Group py="xl">
        <Button type="button" variant="filled" size="lg" onClick={() => handleSubmit(form.values)}>
          Save
        </Button>
      </Group>
    </form>
  );
};
